import styled from '@emotion/styled';
import { Flex } from '$components/layouts';

const Custom500 = (): JSX.Element => {
    return (
        <TextContainer justifyContent="center" alignItems="center" flex column>
            <h1>Server fejl</h1>
            <p>En fejl er sket i vores system</p>
            <p>Prøv igen, eller vent lidt tid, så burde vi være tilbage</p>
        </TextContainer>
    );
};

export default Custom500;

const TextContainer = styled(Flex)(({ theme }) => ({
    padding: `0 ${theme.space[6]} 0 ${theme.space[6]}`,
    minHeight: '100vh',
}));
